/**
 * @pie-players/pie-calculator-desmos
 *
 * Desmos calculator provider - High-quality graphing calculators.
 */

export { DesmosCalculatorProvider } from "./desmos-provider.js";
